import React from "react";
import CustomBreadCrumbs from "../../../components/CustomBreadCrumbs";
import PasswordStep from "../../ForgotPassword/PasswordStep";
import StepUpModal from "../security/StepUpModal";
import useChangePasswordV2 from "./useChangePasswordV2";

// My Profile → Change Password on step-up + /mfa/password (docs/specs/password-reset-stepup.md, 7b.5).
// Shown by ChangePasswordGate only with MFA login V2 (it needs an MFA session) and REACT_APP_PASSWORD_RESET_V2.
const ChangePasswordV2 = () => {
  const { authenticator, stepUp, busy, error, done, save } = useChangePasswordV2();

  let body;
  if (authenticator.loading) body = <p role="status">Loading…</p>;
  else if (authenticator.error) body = <p className="text-danger" role="alert">{authenticator.error}</p>;
  else if (done) body = <p role="status">Password changed. Use it the next time you sign in.</p>;
  else body = <PasswordStep busy={busy} error={error} onSubmit={save} submitLabel="Change password" />;

  return (
    <section className="rounded container-fluid" style={{ background: "#eeeeee", minHeight: "100vh" }}>
      <div className="p-3 pb-0 mt-1">
        <CustomBreadCrumbs crumbs={[{ title: "Profile", link: "/manage-account" }, { title: "Change Password", link: "" }]} />
        <div className="bg-white rounded p-4" style={{ maxWidth: 520 }}>
          <p className="text-muted small">We&apos;ll ask you to confirm it&apos;s you before the new password is saved.</p>
          {body}
        </div>
      </div>
      <StepUpModal
        open={stepUp.open} method={stepUp.method} methods={stepUp.methods} busy={stepUp.busy} error={stepUp.error}
        onSelectMethod={stepUp.selectMethod} onSubmit={stepUp.submit} onCancel={stepUp.cancel}
        onResend={stepUp.method === "email" ? stepUp.resend : undefined}
      />
    </section>
  );
};

export default ChangePasswordV2;
